import Toggle from "../../shared-components/Toggle";
import { CompanyUpdateInput } from "../../api/Companies";

interface CompanyUpdateToggleProps {
  readOnly: boolean;
  obj: CompanyUpdateInput;
  field: string;
  label: string;
  labelClassName?: string;
  tooltip?: string;
  callback: (key: string, value: boolean) => void;
  classNames?: string;
}

const CompanyUpdateToggle: React.FC<CompanyUpdateToggleProps> = ({
  readOnly,
  obj,
  field,
  label,
  labelClassName,
  tooltip,
  callback,
  classNames,
}) => {
  let defaultValue = obj.updates.get(field);
  if (field.includes(".")) {
    const chunks: string[] = field.split(".");
    const intermediate: Object = obj.updates.get(chunks[0]) ?? {};
    defaultValue = intermediate[chunks[1] as keyof typeof intermediate];
    if (typeof defaultValue === typeof "") {
      const truthy = ["1", "T", "t", "TRUE", "true", "True", "y"];
      defaultValue = truthy.includes(defaultValue) ? true : false;
    }
  }
  return (
    <div key={field} className={classNames ?? "mb-4 w-64"}>
      <Toggle
        defaultValue={defaultValue}
        disabled={readOnly}
        label={label}
        labelClassName={labelClassName}
        tooltip={tooltip}
        onChange={(e: boolean) => callback(field, e)}
      />
    </div>
  );
};

export default CompanyUpdateToggle;
